import PropTypes from "prop-types";
import {css} from "@emotion/react";

const PageBody = ({children}) => {
    const bodyCss = css`
        min-height: 200px;
    `;

    return (
        <div className={'main'} css={bodyCss}>
            {children}
        </div>
    );
};

PageBody.propTypes = {
    children: PropTypes.object,
};

export default PageBody;
